import type { Ref } from "vue"
import { defineStore } from "pinia"
import { ref } from "vue"

export const useEventVaultStore = defineStore("eventVault", () => {
  const eventVaultId: Ref<number | undefined> = ref()
  const albumId: Ref<number | undefined> = ref()
  const slug: Ref<string | undefined> = ref()
  const isHost: Ref<boolean | undefined> = ref(false)

  function setEventVaultId(id?: number) {
    eventVaultId.value = id
  }

  function setAlbumId(id?: number) {
    albumId.value = id
  }

  function setSlug(value?: string) {
    slug.value = value
  }

  function setIsHost(value: boolean) {
    isHost.value = value
  }

  function updateStateFromParams(params: { eventVaultId?: number, albumId?: number, slug?: string }) {
    setEventVaultId(params.eventVaultId)
    setAlbumId(params.albumId)
    setSlug(params.slug)
  }

  return { eventVaultId, albumId, slug, isHost, setAlbumId, setEventVaultId, setSlug, updateStateFromParams, setIsHost }
})
